import { Component, Inject, OnInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';

@Component({
	selector: 'app-modal-info-list',
	templateUrl: './modal-info-list.component.html',
	styleUrls: ['./modal-info-list.component.styl'],
})
export class SharedModalInfoListComponent implements OnInit {

	@Input() title = '';
	@Input() text = '';
	@Input() btnName = '';
	@Input() listItem = [];


	constructor(
		public dialogRef: MatDialogRef<SharedModalInfoListComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.title = data.title ? data.title : '';
		this.text = data.text ? data.text : '';
		this.btnName = data.btnName ? data.btnName : '';
		this.listItem = data.listItem ? data.listItem : '';
	}

	ngOnInit(): void {
	}

	onClose(): void {
		this.dialogRef.close(true);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/modal-info-list/modal-info-list.component.ts